import styles from './InfoContacto.module.css'

const InfoContacto = (props) => {
  return props.contacto.map((c) => (
    <div key={c.id} className={styles.card}>
      <div className={styles.bloque}>
        <div className={styles.encabezado}>
          <i className={`fa fa-phone ${styles.icono}`} aria-hidden="true"></i>
          Teléfono
        </div>
        <ul className={styles.lista}>
          <li>{c.telefono}</li>
        </ul>
      </div>
      <div className={styles.bloque}>
        <div className={styles.encabezado}>
          <i className={`fa fa-envelope-o ${styles.icono}`} aria-hidden="true"></i>
          E-mail Soporte
        </div>
        <ul className={styles.lista}>
          <li>{c.emailSoporte}</li>
        </ul>
      </div>
      <div className={styles.bloque}>
        <div className={styles.encabezado}>
          <i className={`fa fa-envelope-o ${styles.icono}`} aria-hidden="true"></i>
          E-mail cobranzas
        </div>
        <ul className={styles.lista}>
          <li>{c.emailCobranzas}</li>
        </ul>
      </div>
    </div>
  ))
}

export default InfoContacto
